import React from "react";

const Metering = () => {

  return (
    <div className="w-full min-h-screen bg-white font-sans">
      {/* Hero Section */}
      <div className="relative bg-[#14532d] text-white py-12 md:py-16 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px'
          }}> 
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 relative z-10">
          <div className="flex flex-col lg:flex-row items-center justify-between">
            <div className="lg:w-2/3">
              <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight uppercase tracking-tight">
              Metering <span className="text-yellow-400">GAP</span>
              </h1>
              <div className="w-20 h-1.5 bg-yellow-400 rounded-full mb-6"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6 md:py-8">
        <div className="bg-black text-white p-4 sm:p-6 md:p-8 mb-6 shadow-xl rounded-xl md:rounded-2xl border-l-[6px] md:border-l-[8px] border-green-700 relative overflow-hidden group">
          <div className="absolute top-0 right-0 w-64 h-64 bg-green-700/10 rounded-full -mr-32 -mt-32 group-hover:scale-110 transition-transform duration-700"></div>
          <p className="text-base sm:text-lg md:text-xl font-black  tracking-tight relative z-10 leading-tight">
            As part of BEDC's commitment to closing the metering gap, we continue with the Meter Asset Providers (MAP) Scheme.
          </p>
        </div>

        <div className="relative mb-6 rounded-xl overflow-hidden shadow-xl border-4 border-white ring-1 ring-gray-100 transform hover:scale-[1.01] transition-transform duration-500">
          <img
            src="/images/METERING.png"
            alt="Metering Commitment"
            className="w-full h-auto object-cover max-h-[350px]"
          />
        </div>

        <div className="relative bg-[#14532d] rounded-xl md:rounded-2xl p-5 sm:p-6 md:p-8 flex flex-col lg:flex-row items-center justify-between gap-6 shadow-xl overflow-hidden group">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-32 -mt-32 group-hover:scale-110 transition-transform duration-700"></div>

          <div className="text-center lg:text-left relative z-10 lg:w-2/3">
            <h2 className="text-lg sm:text-xl md:text-2xl font-black text-white mb-2 uppercase tracking-tighter leading-tight">
              Order a Meter with <span className="text-yellow-400 block">Meter Asset Provider (MAP)</span>
            </h2>
            <div className="w-16 h-1.5 bg-yellow-400 mb-3 hidden lg:block rounded-full"></div>
            <p className="text-green-50 text-xs sm:text-sm md:text-base font-medium opacity-90 leading-relaxed italic">
              Click the order now button to start your step-by-step meter acquisition process today.
            </p>
          </div>

          <div className="flex-shrink-0 relative z-10 lg:w-1/3 flex justify-center lg:justify-end w-full">
            <a href="https://imaap.beninelectric.com" target="blank" className="w-full lg:w-auto">
              <button className="w-full lg:w-auto bg-yellow-400 text-black font-black py-3 px-8 rounded-xl hover:bg-black hover:text-white transition-all duration-300 text-xs uppercase tracking-widest shadow-lg transform group-hover:-translate-y-1">
                Order Now →
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Metering;